import React from 'react'
import AdminReservationEdit from '../../components/admin/reservations/admin-reservation-edit'
import AdminTemplate from '../../templates/admin-template'


const AdminReservationsEditPage = () => {
  return (
    <AdminTemplate>
        <AdminReservationEdit/>
    </AdminTemplate>
  )
}

export default AdminReservationsEditPage